import { Download } from 'lucide-react';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';

type FileType = 'csv' | 'excel';

type Props = {
  onClick: () => void;
  fileType: FileType;
  changeTypeFile: (type: FileType) => void;
};

export const ExportTableMenu = ({
  onClick,
  fileType,
  changeTypeFile
}: Props) => (
  <div className="size-full">
    <p className="text-muted-foreground text-sm">Select a format</p>
    <div className="my-1 flex h-9 items-center gap-1 overflow-hidden rounded-md border border-border bg-accent p-[2px]">
      <FileToggle
        checked={fileType === 'csv'}
        data-cy="export-csv"
        label="CSV"
        onClick={() => changeTypeFile('csv')}
      />
      <FileToggle
        checked={fileType === 'excel'}
        data-cy="export-excel"
        label="Excel"
        onClick={() => changeTypeFile('excel')}
      />
    </div>
    <footer className="mt-4 flex justify-end">
      <Button
        className="flex w-full items-center gap-2"
        data-cy="export-button"
        onClick={onClick}
      >
        <Download />
        Export table as {fileType}
      </Button>
    </footer>
  </div>
);

type FileToggleProps = {
  label: string;
  checked: boolean;
  onClick: () => void;
};

const FileToggle = ({ label, checked, onClick, ...props }: FileToggleProps) => (
  <div
    className={cn(
      'flex h-full grow cursor-pointer items-center justify-center rounded border border-transparent text-sm transition-colors hover:border-border hover:bg-popover hover:text-popover-foreground',
      checked && 'border-border bg-popover text-popover-foreground'
    )}
    onClick={onClick}
    {...props}
  >
    {label}
  </div>
);
